import styled from 'styled-components'

const Footer = styled.footer`
  text-align: center;
  padding: 25px 0;
  border-top: 1px solid rgba(0, 16, 64, 0.08);
  margin-top: 50px;
  color: #9dacb6;
  font-size: 85%;
  background: white;
`

export default Footer
